import profileAvatar from "../../../images/profileAvatar.jpg";

function ProfileCard({ profile, role, scope, fallbackName }) {
    const accentClass = role === "tecnico"
        ? "text-red-400 border-red-500/40 bg-red-500/10"
        : "text-green-400 border-green-500/40 bg-green-500/10";
    const activeProfile = role === "tecnico" ? profile?.tecnicoProfile : profile?.jugadorProfile;
    const displayName = activeProfile?.nombre || profile?.principalProfile?.nombre || fallbackName || "-";
    const scopeLabel = scope === "carrera" ? "Carrera total" : (scope || "-");
    const imageSrc = profile?.principalProfile?.pendImage ? profileAvatar : profile?.imageUrl;

    return (
        <div className="rounded-2xl border border-white/10 bg-[#102216]/70 p-2 sm:p-4 md:p-5 text-center">
            <div className="mx-auto mb-2 sm:mb-3 md:mb-4 w-20 h-24 sm:w-32 sm:h-40 md:w-48 md:h-64 rounded-2xl overflow-hidden">
                <img
                    src={imageSrc}
                    alt={displayName}
                    className="w-full h-full object-cover"
                    onError={(event) => {
                        event.currentTarget.src = profileAvatar;
                    }}
                />
            </div>

            <div className="flex flex-col items-center gap-1 mb-1 sm:mb-1.5 md:mb-2">
                <p className={`inline-flex px-1.5 sm:px-2.5 py-0.5 rounded-full border text-[9px] sm:text-xs font-bold uppercase tracking-[0.12em] sm:tracking-[0.15em] ${accentClass}`}>
                    {role === "tecnico" ? "Técnico" : "Jugador"}
                </p>
            </div>
            <h3 className="text-base sm:text-xl md:text-2xl font-black uppercase text-white tracking-tight break-words leading-tight">{displayName}</h3>
            <p className="mt-0.5 sm:mt-1 md:mt-2 text-[8px] sm:text-[10px] md:text-xs uppercase tracking-[0.1em] sm:tracking-[0.15em] text-slate-400">
                {scopeLabel}
            </p>
        </div>
    );
}

export default function CompararProfilesSection({
    leftProfile,
    rightProfile,
    leftRole,
    rightRole,
    leftScope,
    rightScope,
    leftName,
    rightName,
}) {
    return (
        <section className="mb-6 sm:mb-10">
            <div className="grid grid-cols-2 lg:grid-cols-2 gap-2 sm:gap-3 md:gap-4 lg:gap-12 xl:gap-16 relative items-end">
                <ProfileCard
                    profile={leftProfile}
                    role={leftRole}
                    scope={leftScope}
                    fallbackName={leftName}
                />

                <div className="hidden lg:flex absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 justify-center">
                    <span className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-white/10 bg-[#0f1f15] text-sm font-black uppercase tracking-wider text-slate-400 shadow-lg">
                        VS
                    </span>
                </div>

                <ProfileCard
                    profile={rightProfile}
                    role={rightRole}
                    scope={rightScope}
                    fallbackName={rightName}
                />
            </div>
        </section>
    );
}